import React, { forwardRef, useEffect, useMemo, useState } from 'react';
import {ComboSubFuncionesContainer as ComboSubFunciones} from '../../../components/Combos/SubFunciones/container';
import {ComboFuncionesContainer as ComboFunciones} from '../../../components/Combos/Funciones/container';
import {
  EuiBasicTable,
  EuiIcon,
  EuiFormRow,
  EuiSpacer,
  EuiButton,
  EuiFlexItem,
  EuiFlexGroup,
  EuiFormFieldset,
  EuiFieldText,
  EuiText,
  EuiFormControlLayoutDelimited
} from '@elastic/eui';
import { stringToFloat, toDecimalString } from '../../../../../shared/utils/numbers';
import { HelpTooltip } from './help';

export const SubFuncionesHorasTable = forwardRef((props, ref) => {
  
  let {funSubHoras, setFunSubHoras, dni, codArea, idDN, maxHoras} = props;

  let [funcion, setFuncion] = useState(undefined)
  let [subfuncion, setSubfuncion] = useState(undefined)
  let [nHoras,setNhoras] = useState('0')
  let [pHoras,setPhoras] = useState('0')

  useEffect(()=>{
    setSubfuncion(undefined)
    setNhoras('0')
    setPhoras('0')
  },[funSubHoras])

  const deleteItem = (idSubFuncion, idFuncion) =>{
    let pos = funSubHoras.findIndex((o) => o.idSubFuncion === idSubFuncion && o.idFuncion === idFuncion);
    let newData = [ ...funSubHoras ];
    newData.splice(pos, 1);

    setFunSubHoras(newData)
  }

  const parseNHoras = (value) => (stringToFloat(value)*(maxHoras!==undefined?maxHoras:0))/100
  const parsePHoras = (value) => (stringToFloat(value)*100)/maxHoras

  const getNHorasTotales = useMemo(() => funSubHoras.reduce((a, b) => a + (b['nHoras'] || 0), 0),[funSubHoras])
  const getPHorasTotales = useMemo(() => funSubHoras.reduce((a, b) => a + (b['porcentaje'] || 0), 0),[funSubHoras])

  const onChangeHoras = (type, value) =>{
    let calc = 0;
    const valueFormat = value.replace(',','.');
    
    if(type==='p')
    {
      calc = parseNHoras(valueFormat)
      setPhoras(valueFormat.length>3 ? (valueFormat.split('.')[1].length>1 ? valueFormat.slice(0,3) : valueFormat) : valueFormat)
      //setNhoras(toDecimalString(calc,2).replace(',','.'))
      setNhoras('0');
    }else{
      calc = parsePHoras(valueFormat)
      setNhoras(valueFormat)
      //setPhoras(toDecimalString(calc,0).replace(',','.'))
      setPhoras('0')
    }
  }
  
  const columns = [
    {
      field: 'subFuncion',
      name: 'SubFunción',
      sortable: true,
      header: false,
      truncateText: true,
      enlarge: true,
      fullWidth: true,
      width: '50%',
      dataType:"string",
      render: (data) => {
        return <EuiText title={data} size='s'>{data}</EuiText>;
      }
    },
    {
      field: 'funcion',
      name: 'Función',
      sortable: true,
      header: false,
      truncateText: true,
      enlarge: true,
      fullWidth: true,
      width: '25%',
      dataType:"string",
      render: (data) => {
        return <EuiText title={data} size='s'>{data}</EuiText>;
      }
    },
    {
      field: 'nHoras',
      name: 'Nº Horas',
      sortable: true,
      header: false,
      truncateText: false,
      enlarge: false,
      fullWidth: false,
      dataType:"number",
      align:'right',
      render: (data) => {
        //return maxHoras!==undefined ? toDecimalString(data).replace(',','.') : ''
        return data>0 ? toDecimalString(data).replace(',','.') : ''
      }
    },
    {
      field: 'porcentaje',
      name: '%',
      sortable: true,
      header: false,
      truncateText: false,
      enlarge: false,
      fullWidth: false,
      dataType:"number",
      align:'center',
      render: (data) => {
        return data>0 ? toDecimalString(data,0).replace(',','.') : ''
      }
    },
    {
      name: 'Eliminar',
      align:'center',
      render: (data) => {
        return <EuiIcon type="crossInACircleFilled" color="danger" onClick={()=>deleteItem(data.idSubFuncion, data.idFuncion)}/>;
      }
    }
  ];

  const onAgregate = () =>{
    let newData = [{idFuncion: funcion[0].value, funcion: funcion[0].label, idSubFuncion:subfuncion[0].value, subFuncion:subfuncion[0].label, 
      nHoras: stringToFloat(nHoras), porcentaje:stringToFloat(pHoras)}]
      //porcentaje:parsePHoras(nHoras) 
      setFunSubHoras([...funSubHoras, ...newData])
  }

  const labelHoras = useMemo(()=>{
    return (
      <span>
      {`Nº Horas Diarias ${maxHoras!==undefined ? `(${toDecimalString(getNHorasTotales,2)}h)` : `` }`}
      <HelpTooltip message={maxHoras!==undefined?`Imputación máxima día (${maxHoras} horas)`:``} position="top" adjust/>
      </span>
    )
  },[getNHorasTotales,maxHoras])

  const getRowProps = (item) => {
    const { id } = item;
    return {
      'data-test-subj': `row-${id}`,
      className: 'customRowClass',
      onClick: () => {},
    };
  };

  const getCellProps = (item, column) => {
    const { id } = item;
    const { field } = column;
    return {
      className: 'customCellClass',
      'data-test-subj': `cell-${id}-${field}`,
      textOnly: true,
    };
  };

  const errorHoras = useMemo(() => {return nHoras===undefined || nHoras.trim()==="" || (isNaN(stringToFloat(nHoras)))},[nHoras])
  //const errorHoras = useMemo(() => {return nHoras===undefined || (isNaN(nHoras))},[nHoras])
  const isInvalidSubFuncion = useMemo(() => {return subfuncion===undefined},[subfuncion])
  const isInvalidFuncion = useMemo(() => funcion===undefined || funcion.length===0,[funcion])
  const isInvalidData = useMemo(() => funSubHoras.length===0 || getNHorasTotales>maxHoras,[funSubHoras,getNHorasTotales,maxHoras])
  const isInvalidAdd = useMemo(() => isInvalidSubFuncion || errorHoras || (stringToFloat(pHoras)>100 || (getPHorasTotales+stringToFloat(pHoras))>100) || (maxHoras!==undefined ? getNHorasTotales>maxHoras : false),[subfuncion,nHoras,getNHorasTotales,pHoras,getPHorasTotales,maxHoras])

  const getTitle = useMemo(() => `Funciones / SubFunciones / Horas Diarias${getNHorasTotales>0?(getNHorasTotales>maxHoras ?  `(Exceso de Horas ${toDecimalString(getNHorasTotales,2)}h)` :  `(${toDecimalString(getNHorasTotales,2)}h)`):``}`,[getNHorasTotales,maxHoras])

  return (
    <EuiFormFieldset legend={{children:getTitle}} className={isInvalidData ? "invalidFunSubHorasFieldset" : "validFunSubHorasFieldset"}>
      <EuiFlexGroup gutterSize="s" wrap>
        <EuiFlexItem style={{width:'25%'}}>
          <EuiFormRow label="Función" fullWidth>
            <ComboFunciones fullWidth selectedOptions={funcion} onChange={value => setFuncion(value)} dni={dni} />
          </EuiFormRow>
          </EuiFlexItem>
          <EuiFlexItem style={{width:'50%'}}>
            <EuiFormRow label="SubFunciones" fullWidth>
              <ComboSubFunciones fullWidth idFuncion={!isInvalidFuncion ? funcion[0].value : undefined} codArea={codArea} idDN={idDN} 
              isDisabled={!isInvalidFuncion ? false : true}  
              selectedOptions={subfuncion} onChange={value => setSubfuncion(value)} dependency/>
            </EuiFormRow>
          </EuiFlexItem>
      <EuiFlexItem style={{width:'25%'}}>
          <EuiFormRow fullWidth label={labelHoras} isInvalid={getNHorasTotales>maxHoras}>
          <EuiFormControlLayoutDelimited
            fullWidth
            isInvalid={getNHorasTotales>maxHoras}
            prepend={'Nº'}
            startControl={
              <EuiFieldText value={nHoras!=='0'?nHoras:''} name="txtNhoras" onChange={e => onChangeHoras('n',e.target.value)} isInvalid={getNHorasTotales>maxHoras} 
              disabled={getNHorasTotales>maxHoras || getPHorasTotales>0} maxLength={4}/>
            }
            delimiter={<EuiIcon type="merge" />}
            append={'%'}
            endControl={
              <EuiFieldText value={pHoras!=='0'?pHoras:''} name="txtPhoras" onChange={e => onChangeHoras('p',e.target.value)} isInvalid={getNHorasTotales>maxHoras} 
              disabled={getNHorasTotales>maxHoras || getNHorasTotales>0} maxLength={3}/>
            }
          />
          </EuiFormRow>
        </EuiFlexItem>
        <EuiFlexItem grow={false}>
          <EuiFormRow hasEmptyLabelSpace>
            <EuiButton fill onClick={onAgregate} color={'primary'} disabled={isInvalidAdd} fullWidth className="btnFunSubHorasAdd">Agregar</EuiButton>
          </EuiFormRow>
        </EuiFlexItem>
      </EuiFlexGroup>

        {/* <EuiFlexItem style={{marginTop:'5px'}}>
        <EuiButton fill onClick={onAgregate} color={'primary'} disabled={isInvalidAdd} fullWidth className="btnFunSubHorasAdd">Agregar</EuiButton>
        </EuiFlexItem> */}
        
        <EuiSpacer size="s" />
        <EuiFlexItem style={{overflow: 'auto',maxHeight: '200px'}}>
          <EuiBasicTable
            compressed
            items={funSubHoras}
            columns={columns}
            tableLayout='fixed'
            rowProps={getRowProps}
            cellProps={getCellProps}
          />
        </EuiFlexItem>
      </EuiFormFieldset>
  )
});
export default SubFuncionesHorasTable